import { useModalActions } from '@carboncopyco/components';
import rendererService from '../services/RendererService';

export function useFocusAppService() {
  const { closeAllModals } = useModalActions();
  const triggerFocus = (isOpen: boolean) => {
    rendererService.setHasOpenModals(isOpen);
    if (isOpen) {
      rendererService.focusApp();
    } else {
      rendererService.blurApp();
    }
  };

  const hideOpenDropdown = () => {
    const dropdowns = document.querySelector('[role=menu]');
    if (dropdowns) dropdowns.remove();
  };

  const hideOnSwitchFocus = () => {
    hideOpenDropdown();
    closeAllModals();
  };

  return {
    triggerFocus,
    isAppViewFocus: rendererService.isAppViewFocus,
    hideOpenDropdown,
    hideOnSwitchFocus,
  };
}
